import type { DailyStatistic } from '@features/statistics/types'

export const EMPTY_DAILY_STATISTICS: DailyStatistic[] = [
  { value: 0, splitValue: [0], unit: '', title: '' },
  { value: 0, splitValue: [0], unit: '', title: '' },
  {
    value: 0,
    splitValue: [0],
    unit: 'мин',
    title: 'Среднее <br/> время доставки',
  },
  { value: 0, splitValue: [0], unit: '', title: 'Заказов выполнено' },
  {
    value: 0,
    splitValue: [0],
    unit: 'км',
    title: 'Проехали наши курьеры',
  },
  { value: 0, splitValue: [0], unit: '', title: 'Человек <br/> мы накормили' },
  { value: 0, splitValue: [0], unit: '', title: '' },
  {
    value: 0,
    splitValue: [0],
    unit: 'млн',
    title: 'Заказов за всё время',
  },
]

export const DAILY_STATISTIC_PRESENTATION: Record<
  number,
  Pick<DailyStatistic, 'unit' | 'title'> | null
> = {
  0: { unit: 'городов', title: '' },
  1: { unit: 'кухонь', title: '' },
  2: { unit: 'минут', title: 'Среднее время доставки' },
  3: { unit: 'заказов', title: 'За сегодня приготовили' },
  4: { unit: 'км', title: 'Наши курьеры проехали' },
  5: null,
  6: { unit: 'сотрудников', title: 'Для вас стараются' },
  7: null,
}
